import axios from './axios';
import { appConfig, CONNECTION_TIMEOUT } from '../../config';
import { TransactionStatusType } from '@bus/models';
import { SubmitAnswersRequestBody } from '../../shared/interface';

export async function saveAndContinueLater(
  saveForLaterData: SubmitAnswersRequestBody,
  transactionId: string,
  transactionStatus: TransactionStatusType
): Promise<{ statusCode: number; body: any }> {
  const url = `/api/${appConfig.brandName}/save/${transactionId}/${transactionStatus}/saveForLater`;
  return axios
    .post(url, saveForLaterData, {
      headers: {
        'Cache-Control': 'no-cache, no-store',
        Pragma: 'no-cache'
      },
      timeout: CONNECTION_TIMEOUT,
      validateStatus: (statusCode) => statusCode === 200
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
}
